// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    traderPrivateGetV2Account (params?: {}): Promise<Dict>;
    traderPrivateGetV2Orders (params?: {}): Promise<List>;
    traderPrivateGetV2OrdersOrderId (params?: {}): Promise<Dict>;
    traderPrivateGetV2Positions (params?: {}): Promise<List>;
    traderPrivateGetV2PositionsSymbolOrAssetId (params?: {}): Promise<Dict>;
    traderPrivateGetV2AccountPortfolioHistory (params?: {}): Promise<Dict>;
    traderPrivateGetV2Watchlists (params?: {}): Promise<List>;
    traderPrivateGetV2WatchlistsWatchlistId (params?: {}): Promise<Dict>;
    traderPrivateGetV2WatchlistsByName (params?: {}): Promise<Dict>;
    traderPrivateGetV2AccountConfigurations (params?: {}): Promise<Dict>;
    traderPrivateGetV2AccountActivities (params?: {}): Promise<List>;
    traderPrivateGetV2AccountActivitiesActivityType (params?: {}): Promise<List>;
    traderPrivateGetV2Calendar (params?: {}): Promise<List>;
    traderPrivateGetV2Clock (params?: {}): Promise<Dict>;
    traderPrivateGetV2Assets (params?: {}): Promise<List>;
    traderPrivateGetV2AssetsSymbolOrAssetId (params?: {}): Promise<Dict>;
    traderPrivateGetV2CorporateActionsAnnouncementsId (params?: {}): Promise<Dict>;
    traderPrivateGetV2CorporateActionsAnnouncements (params?: {}): Promise<List>;
    traderPrivateGetV2Wallets (params?: {}): Promise<Dict>;
    traderPrivateGetV2WalletsTransfers (params?: {}): Promise<List>;
    traderPrivatePostV2Orders (params?: {}): Promise<Dict>;
    traderPrivatePostV2Watchlists (params?: {}): Promise<Dict>;
    traderPrivatePostV2WatchlistsWatchlistId (params?: {}): Promise<Dict>;
    traderPrivatePostV2WatchlistsByName (params?: {}): Promise<Dict>;
    traderPrivatePostV2WalletsTransfers (params?: {}): Promise<Dict>;
    traderPrivatePutV2OrdersOrderId (params?: {}): Promise<Dict>;
    traderPrivatePutV2WatchlistsWatchlistId (params?: {}): Promise<Dict>;
    traderPrivatePutV2WatchlistsByName (params?: {}): Promise<Dict>;
    traderPrivatePatchV2OrdersOrderId (params?: {}): Promise<Dict>;
    traderPrivatePatchV2AccountConfigurations (params?: {}): Promise<Dict>;
    traderPrivateDeleteV2Orders (params?: {}): Promise<List>;
    traderPrivateDeleteV2OrdersOrderId (params?: {}): Promise<Dict>;
    traderPrivateDeleteV2Positions (params?: {}): Promise<List>;
    traderPrivateDeleteV2PositionsSymbolOrAssetId (params?: {}): Promise<Dict>;
    traderPrivateDeleteV2WatchlistsWatchlistId (params?: {}): Promise<Dict>;
    traderPrivateDeleteV2WatchlistsByName (params?: {}): Promise<Dict>;
    traderPrivateDeleteV2WatchlistsWatchlistIdSymbol (params?: {}): Promise<Dict>;
    marketPublicGetV1beta3CryptoLocBars (params?: {}): Promise<Dict>;
    marketPublicGetV1beta3CryptoLocLatestBars (params?: {}): Promise<Dict>;
    marketPublicGetV1beta3CryptoLocLatestOrderbooks (params?: {}): Promise<Dict>;
    marketPublicGetV1beta3CryptoLocLatestQuotes (params?: {}): Promise<Dict>;
    marketPublicGetV1beta3CryptoLocLatestTrades (params?: {}): Promise<Dict>;
    marketPublicGetV1beta3CryptoLocQuotes (params?: {}): Promise<Dict>;
    marketPublicGetV1beta3CryptoLocSnapshots (params?: {}): Promise<Dict>;
    marketPublicGetV1beta3CryptoLocTrades (params?: {}): Promise<Dict>;
    marketPrivateGetV1beta1CorporateActions (params?: {}): Promise<Dict>;
    marketPrivateGetV1beta1ForexLatestRates (params?: {}): Promise<Dict>;
    marketPrivateGetV1beta1ForexRates (params?: {}): Promise<Dict>;
    marketPrivateGetV1beta1LogosSymbol (params?: {}): Promise<string>;
    marketPrivateGetV1beta1News (params?: {}): Promise<Dict>;
    marketPrivateGetV1beta1ScreenerStocksMostActives (params?: {}): Promise<Dict>;
    marketPrivateGetV1beta1ScreenerMarketTypeMovers (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksAuctions (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksBars (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksBarsLatest (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksMetaConditionsTicktype (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksMetaExchanges (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksQuotes (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksQuotesLatest (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksSnapshots (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksTrades (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksTradesLatest (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksSymbolAuctions (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksSymbolBars (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksSymbolBarsLatest (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksSymbolQuotes (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksSymbolQuotesLatest (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksSymbolSnapshot (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksSymbolTrades (params?: {}): Promise<Dict>;
    marketPrivateGetV2StocksSymbolTradesLatest (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
